import { RefreshCw } from 'lucide-react';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface TableHeaderButtonProps {
  onClick: () => void;
  children: React.ReactNode;

  disabled: boolean;
}

const TableHeaderButton: FC<TableHeaderButtonProps> = ({ disabled, onClick, children }) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={twMerge(
        'flex h-10 w-44 items-center justify-center gap-2 rounded-lg border border-ph-purple bg-transparent px-3 text-sm font-bold text-ph-purple',
        disabled
          ? 'border-ph-gray-baltic bg-ph-gray-baltic text-ph-gray-jumbo hover:cursor-not-allowed'
          : 'transition-colors duration-200 hover:bg-ph-purple hover:bg-opacity-10',
      )}
    >
      <RefreshCw size={14} className="text-ph-purple" />
      {children}
    </button>
  );
};

export default TableHeaderButton;
